/** Used for resources that don't require any particular scope, like domains */
export const NO_REQUIRED_SCOPE = "";

/**
 * ShopifyReadWriteScopes are unprefixed scope IDs, where `read_<resource>` and `write_<resource>` exist as Shopify access scope IDs/"handlers"
 * https://shopify.dev/api/admin/access-scopes
 */
export const ShopifyReadWriteScopes = [
  "assigned_fulfillment_orders",
  "cart_transforms",
  "checkouts",
  "content",
  "customer_merge",
  "customer_payment_methods",
  "customers",
  "delivery_customizations",
  "discounts",
  "draft_orders",
  "files",
  "fulfillments",
  "gift_cards",
  "inventory",
  "locales",
  "marketing_events",
  "markets",
  "merchant_managed_fulfillment_orders",
  "metaobject_definitions",
  "metaobjects",
  "order_edits",
  "orders",
  "own_subscription_contracts",
  "payment_customizations",
  "price_rules",
  "privacy_settings",
  "products",
  "publications",
  "purchase_options",
  "reports",
  "resource_feedbacks",
  "returns",
  "script_tags",
  "shipping",
  "shopify_payments_dispute_evidences",
  "store_credit_account_transactions",
  "themes",
  "third_party_fulfillment_orders",
  "translations",
  "gift_card_adjustments",
  "payment_mandate",
  "checkout_branding_settings",
  "payment_terms",
  "validations",
  "locations",
  "discounts_allocator_functions",
];

/**
 * ShopifySimpleScopes are strings that each fully match a Shopify authenticated access scope ID
 * https://shopify.dev/api/admin/access-scopes
 */
export const ShopifySimpleScopes = [
  "read_all_orders",
  "read_product_listings",
  "read_shopify_payments_disputes",
  "read_shopify_payments_payouts",
  "read_users",
  "write_pixels",
  "read_customer_events",
  "read_audit_events",
  "read_legal_policies",
  "read_merchant_approval_signals",
  "read_store_credit_accounts",
  "write_payment_gateways",
  "write_payment_sessions",
];

/**
 * https://shopify.dev/api/admin/access-scopes
 */
export const AllShopifyScopes = [...ShopifyReadWriteScopes.flatMap((s) => [`read_${s}`, `write_${s}`]), ...ShopifySimpleScopes];

export const CoreShopifyScopes = ["products", "orders", "customers", "checkouts"];

export const namespaceFromScope = (scope: string) => (ShopifySimpleScopes.includes(scope) ? scope : scope.replace(/^(read|write)_/, ""));
